import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import TextButton from 'LuxKit/Button/TextButton'
import { horizontalChildSpacing } from 'components/utils/spacing'
import SelectTourType from 'tripPlanner/components/TripModal/TripItems/Variety/SelectTourType'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

type Props = {
  tripId: string
  beforeClick?: () => void
}

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${rem(24)};
  width: 100%;

  ${horizontalChildSpacing[16]}
`

function TourCTA({ tripId, beforeClick }: Props) {
  const intl = useIntl()
  const openModal = useOpenModal()
  return (
    <Buttons>
      <TextButton
        kind="primary"
        onClick={() => {
          beforeClick?.()
          openModal(SelectTourType, {
            tripId,
          })
        }}
      >
        {intl.formatMessage({
          id: '125__qmpJm5_NqcxIWcP',
          defaultMessage: 'Search tours',
          description: 'Action button to open tour search modal in trip planner',
        })}
      </TextButton>
      <TextButton
        kind="secondary"
        onClick={() => {
          beforeClick?.()
          openModal(SelectTourType, {
            tripId,
          })
        }}
      >
        {intl.formatMessage({
          id: 'gB1sPckAZ-dAAvDaMvXP',
          defaultMessage: 'Add your own',
          description: 'Button to manually add a custom tour to trip planner',
        })}
      </TextButton>
    </Buttons>
  )
}

export default TourCTA
